import { applicationApi } from '../../common/api';
import { Event, EventParticipant, EventSchedule } from './types';

// Define a service using a base URL and expected endpoints
export const eventApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllEvent: builder.query<Event[], void>({
      query: () => `event/data`,
      providesTags: [{ type: 'Event', id: 'LIST' }],
    }),
    getEvent: builder.query<Event, string>({
      query: (query) => `event/data/${query}`,
      providesTags: [{ type: 'Event', id: 'SINGLE' }],
    }),
    createEvent: builder.mutation<Event, any>({
      query: (body) => ({
        url: '/event/data',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Event', id: 'LIST' }],
    }),
    deleteEvent: builder.mutation<any, number>({
      query: (id) => ({
        url: `event/data${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Event', id: 'LIST' }],
    }),
    updateEvent: builder.mutation<Event, any>({
      query: (body) => ({
        url: '/event/data',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'Event', id: 'LIST' }],
    }),
    getEventSchedule: builder.query<EventSchedule, string>({
      query: (query) => `event/schedule/${query}`,
      providesTags: [{ type: 'EventSchedule', id: 'SINGLE' }],
    }),
    getAllEventSchedule: builder.query<EventSchedule[], void>({
      query: () => `event/schedule`,
      providesTags: [{ type: 'EventSchedule', id: 'LIST' }],
    }),
    createEventSchedule: builder.mutation<EventSchedule, any>({
      query: (body) => ({
        url: '/event/schedule',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'EventSchedule', id: 'SINGLE' }],
    }),
    deleteEventSchedule: builder.mutation<any, number>({
      query: (id) => ({
        url: `event/schedule/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'EventSchedule', id: 'SINGLE' }],
    }),
    updateEventSchedule: builder.mutation<EventSchedule, any>({
      query: (body) => ({
        url: '/event/schedule',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'EventSchedule', id: 'SINGLE' }],
    }),
    createEventParticipant: builder.mutation<EventParticipant, any>({
      query: (body) => ({
        url: '/event/participant',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'EventParticipant', id: 'SINGLE' }],
    }),
    deleteEventParticipant: builder.mutation<any, number>({
      query: (id) => ({
        url: `event/participant/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'EventParticipant', id: 'SINGLE' }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllEventQuery,
  useGetEventQuery,
  useCreateEventMutation,
  useDeleteEventMutation,
  useUpdateEventMutation,
  useGetEventScheduleQuery,
  useGetAllEventScheduleQuery,
  useDeleteEventScheduleMutation,
  useCreateEventScheduleMutation,
  useUpdateEventScheduleMutation,
  useCreateEventParticipantMutation,
  useDeleteEventParticipantMutation,
} = eventApi;
